import React from "react";
import "../css/admission.css";
import poster from "../img/panplate.jpg";

const Admission = () => {
  return (
    <div className="admission-page container my-5">
      {/* Header */}
      <div className="text-center mb-4">
        <h2 className="fw-bold text-primary">Admission Details</h2>
        <p className="text-muted">
          Join Auxilium Private Technical Training Centre — empowering skilled professionals for the future.
        </p>
      </div>

      {/* Admission Poster */}
      <div className="poster-container text-center mb-5">
        <img
          src={poster}
          alt="Admission Poster"
          className="img-fluid rounded shadow"
          style={{ maxWidth: "50%", height: "auto" }}
        />
      </div>

      {/* Admission Form Section 
      <div className="admission-form-section p-4 p-md-5 shadow rounded bg-light">
        <h4 className="fw-bold text-center mb-4 text-primary">Apply for Admission</h4>
        <form className="row g-3">
          <div className="col-md-6">
            <label className="form-label">Full Name</label>
            <input type="text" className="form-control" placeholder="Enter your name" required />
          </div>
          <div className="col-md-6">
            <label className="form-label">Email</label>
            <input type="email" className="form-control" placeholder="Enter your email" required />
          </div>
          <div className="col-md-6">
            <label className="form-label">Phone Number</label>
            <input type="tel" className="form-control" placeholder="Enter your mobile number" required />
          </div>
          <div className="col-md-6">
            <label className="form-label">Course Interested</label>
            <select className="form-select" required>
              <option value="">-- Select Course --</option>
              <option>Electrician (2 Years)</option>
              <option>Welder (1 Year)</option>
              <option>Wireman (2 Years)</option>
              <option>R & AC (3 Months)</option>
              <option>Solar Technician (3 Months)</option>
              <option>Computer & Tally (3 Months)</option>
            </select>
          </div>
          <div className="col-12">
            <label className="form-label">Address</label>
            <textarea className="form-control" rows="3" placeholder="Enter your address"></textarea>
          </div>
          <div className="col-12 text-center">
            <button type="submit" className="btn btn-primary px-5 py-2">
              Submit Application
            </button>
          </div>
        </form>
      </div>*/}

      {/* Contact Info */}
      <div className="text-center mt-5">
        <h5 className="fw-bold">For Admission Enquiry:</h5>
        <p>
          📞 <strong>9385201431</strong> <br />
          📧 <a href="mailto:Auxiliumttc1973@gmail.com">Auxiliumttc1973@gmail.com</a>
        </p>
      </div>
    </div>
  );
};

export default Admission;
